module.exports = __webpack_public_path__ + "static/img/quiz-good@3x.5152f1f7.png";